import pluralize from 'pluralize';

import { IDayRange } from 'components/shared/DatePicker/type';
import { IDatesRange } from 'detailsv2/structure';

// TODO: DELETE IT useless hook
export const useNightsCount = (range?: IDayRange | IDatesRange | string) => {
  if (!range || typeof range === 'string') return { nightsCount: '', nightsCountInWords: '' };

  const nightsCount = range?.start && range?.end && getNightsCount(range.start, range.end);

  const nightsCountInWords = nightsCount ? `${nightsCount} ${pluralize('night', nightsCount)}` : 'Day Room';
  return {
    nightsCount,
    nightsCountInWords,
  };
};

export const getNightsCount = (start: string | number, end?: string | number) => {
  if (!end) return 0;
  if (typeof start === 'number' && typeof end === 'number') {
    return end - start;
  }
  const date1 = new Date(start);
  const date2 = new Date(end);
  // @ts-ignore
  const diffTime = Math.abs(date2 - date1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
